import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logoimage from "./Akoi-logo.png";

const Header = () => {
  const [isHamburger, setIsHamburger] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {/* Sticky Header */}
      <div className="w-full fixed top-0 left-0 right-0 bg-white shadow-lg z-50 border flex justify-between h-20 backdrop-blur-lg bg-opacity-80 transition-all duration-300">
        <div className="z-10">
          <img
            src={Logoimage}
            alt="logo"
            className="h-32 ml-2 md:ml-4 -mt-4 cursor-pointer rounded-full object-contain md:h-28 md:w-40"
            onClick={() => {
              navigate("/");
              scrollToTop();
            }
            }
          />
        </div>

        <nav
          className={`${
            isHamburger ? "flex" : "hidden"
          } md:flex md:items-center md:space-x-8 absolute md:relative top-24 md:top-0 left-0 right-0 h-screen md:h-auto bg-gray-100 md:bg-transparent p-4 md:p-0 z-40`}
        >
          <ul className="flex flex-col px-10 py-2 rounded-sm mx-10 text-white text-xl md:flex-row md:space-x-8 md:space-y-0 space-y-4">
            <Link to="/" onClick={() => { setIsHamburger(false) ; scrollToTop()}}>
              <li className="hover:underline md:hover:text-black cursor-pointer text-amber-700 text-xl font-semibold font-sans">
                Home
              </li>
            </Link>
            <Link to="/adoption-form" onClick={() => {setIsHamburger(false) ; scrollToTop() }}>
              <li className="hover:underline md:hover:text-black cursor-pointer text-amber-700 text-xl font-semibold font-sans">
                Adopt
              </li>
            </Link>
            <Link to="/page-donate" onClick={() => {setIsHamburger(false) ; scrollToTop()}}>
              <li className="hover:underline md:hover:text-black cursor-pointer text-amber-700 text-xl font-semibold font-sans">
                Donate
              </li>
            </Link>
            <Link to="/boarding" onClick={() => {setIsHamburger(false) ; scrollToTop()}}>
              <li className="hover:underline md:hover:text-black cursor-pointer text-amber-700 text-xl font-semibold font-sans">
                Boarding
              </li>
            </Link>
            <Link to="/about" onClick={() =>{ setIsHamburger(false) ; scrollToTop()}}>
              <li className="hover:underline md:hover:text-black cursor-pointer text-amber-700 text-xl font-semibold font-sans">
                About Us
              </li>
            </Link>

            {/* Dropdown for "What We Do" */}
            <div
              className="relative md:hover:text-black cursor-pointer text-amber-700 text-xl font-semibold font-sans"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <div
                className="flex justify-between items-center"
                onClick={handleDropdownToggle}
              >
                <span>What We Do</span>
                <span className="ml-2">{isDropdownOpen ? "▲" : "▼"}</span>
              </div>

              {isDropdownOpen && (
                <div className="absolute bg-white shadow-lg rounded-md p-2 w-64 -left-8">
                  <ul className="text-black">
                    <li className="border p-2 py-4 hover:bg-gray-100 hover:scale-105 cursor-pointer">
                      Rescue and Rehabilitate
                    </li>
                    <li className="border p-2 py-4 hover:bg-gray-100 cursor-pointer hover:scale-105">
                      Spay, Neuter, and Vaccinate
                    </li>
                    <li className="border p-2 py-4 hover:bg-gray-100 cursor-pointer hover:scale-105">
                      Re-Home Dogs and Cats
                    </li>
                    <li className="border p-2 py-4 hover:bg-gray-100 cursor-pointer hover:scale-105">
                      Feed Street Dogs and Bovine
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </ul>
        </nav>

        {/* Hamburger Button */}
        {!isHamburger && (
          <div
            className="p-1 cursor-pointer md:hidden m-4"
            onClick={() => setIsHamburger(true)}
          >
            <div className="bg-gray-600 rounded-lg w-8 h-1 my-1"></div>
            <div className="bg-gray-600 rounded-lg w-8 h-1 my-1"></div>
            <div className="bg-gray-600 rounded-lg w-8 h-1"></div>
          </div>
        )}

        {/* Cancel Button */}
        {isHamburger && (
          <div
            className="p-2 cursor-pointer md:hidden m-4"
            onClick={() => setIsHamburger(false)}
          >
            <div className="bg-gray-600 rounded-lg w-8 h-1 transform rotate-45"></div>
            <div className="bg-gray-600 rounded-lg w-8 h-1 transform -rotate-45 -mt-1"></div>
          </div>
        )}
      </div>

      <div className="h-24"></div>
    </>
  );
};

export default Header;
